import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import * as moment from 'moment';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-ar-link-un',
  templateUrl: './ar-link-un.component.html',
  styleUrls: ['./ar-link-un.component.scss']
})

export class ArLinkUnComponent implements OnInit {

  private notifier: NotifierService;

  miscServices=[];
  passengers = [];
  flightInfo = [];

  taxSlab;

  reservationID;
  station;
  companyName;
  invoiceReceiptId;
  arUnaasingedTransaction = [];
  arUnaasingedAgencies = [];
  arUnaasingedCustomers = [];
  arUnTransactionForm: FormGroup;
  selectedAgencyName;
  invoiceData=[];
  minDate = new Date();
  trasactionTypes = [{
    name: 'Credit Card',
    code: 'CC'
  },
  {
    name: 'Cheque',
    code: 'CQ'
  }
  ]
  activeTab;

  submitted = false;
  tTypeset = false;
  selectedCustomerObject; 

  /**
	 * Constructor
	 *
	 * @param {NotifierService} notifier Notifier service
	 */
  constructor(
    private spinner: NgxSpinnerService, 
    notifierService: NotifierService,
    private route: ActivatedRoute, 
    private router: Router,
    private authService: AuthenticationService,
    private arService: ArService) {

      this.notifier = notifierService;
      this.activeTab = this.route.snapshot.paramMap.get('tib');

  }

  ngOnInit() {
    this.reservationID = this.route.snapshot.paramMap.get('id');
    if(this.reservationID == '' || null ){
      this.onBack();
    }
    this.getTransactionByID();
    this.initAddTransactionForm();
    localStorage.setItem('arActiveTab', this.activeTab);
    
  }

   initAddTransactionForm() {
    let st = moment().format('MM/DD/YYYY');
    this.arUnTransactionForm = new FormGroup({
      subTotal : new FormControl( '', Validators.compose([Validators.required])),
      taxes : new FormControl('', Validators.compose([Validators.required])),
      totalAmount : new FormControl('', Validators.compose([Validators.required])),
      agencyName: new FormControl(''),
      customerName: new FormControl('', Validators.compose([Validators.required])),
      transactionType: new FormControl('', Validators.compose([Validators.required])),
      dueDate: new FormControl('', Validators.compose([Validators.required])),
      purchase_order :  new FormControl('')
    });
  }

  validation_messages = {
    'customerName': [
      { type: 'required', message: 'Company Name is required.' }
    ],
    'transactionType': [
      { type: 'required', message: 'Transaction Type is required.' }
    ],
    'dueDate': [
      { type: 'required', message: 'Due Date is required.' }
    ],
  }

  get formControls(): any {
    return this.arUnTransactionForm.controls;
  }

  validateTransaction() {
    //console.log("callingg...");
    
    if (this.formControls.dueDate.errors) {
      this.notifier.notify('warning', 'Please select Due Date ');
      return false;
    }
     if (this.formControls.customerName.errors) {
      this.notifier.notify('warning', 'Please select Company Name ');
      return false;
    }
    if (this.formControls.transactionType.errors) {
      this.notifier.notify('warning', 'Please select Transaction Type ');
      return false;
    }
  }

  // initUpdateTransactionForm() {
  //   let st = moment().format('MM/DD/YYYY');
  //   this.arUnTransactionForm = new FormGroup({
  //     subTotal : new FormControl( '', Validators.compose([Validators.required])),
  //     taxes : new FormControl('', Validators.compose([Validators.required])),
  //     totalAmount : new FormControl('', Validators.compose([Validators.required])),
  //     agencyName: new FormControl(''),
  //     customerName: new FormControl('', Validators.compose([Validators.required])),
  //     transactionType: new FormControl('', Validators.compose([Validators.required])),
  //     dueDate: new FormControl('')
  //   });
  // }

 async  getTransactionByID() {
    this.spinner.show();
    await this.arService.getTransactionByResId(this.reservationID).subscribe(async res => {
      this.spinner.hide();
      if (res['status'] && res['result'].length > 0) {
        this.arUnaasingedTransaction = res['result'];
        this.arUnTransactionForm.patchValue({
          subTotal : this.arUnaasingedTransaction[0].TRANSACTION_SUBTOTAL,
          taxes : this.arUnaasingedTransaction[0].TRANSACTION_TAXES,
          totalAmount : this.arUnaasingedTransaction[0].TRANSACTION_TOTAL,   
        });
        this.station = this.arUnaasingedTransaction[0].STATION;
        const data = {
          station: this.station
        }

        this.getTaxSlab(data);
        const fiscalYear = new Date(this.arUnaasingedTransaction[0].RESERVATION_DATE).getFullYear().toString().slice(-2);
        const stationCode = this.arUnaasingedTransaction[0].STATION.toString().slice(0,-3);
        const resID = 10000000 + parseInt(this.reservationID);
        this.invoiceReceiptId = fiscalYear + 'AB' + stationCode + '-' + resID;
       console.log(this.arUnaasingedTransaction[0].STATION, this.invoiceReceiptId);

        await this.arService.getAgenciesByStationId(data).subscribe(res => {
          this.spinner.hide();
          if (res['status'] && res['result'].length > 0) {
            this.arUnaasingedAgencies = res['result'];
          }
        });


        await this.arService.getCustomersByStation(data).subscribe(res => {
         // console.log(res['status'] && res['result'].length > 0);
          this.spinner.hide();
          if (res['status'] && res['result'].length > 0) {
            this.arUnaasingedCustomers = res['result'];

            //console.log(this.arUnaasingedCustomers);
          }
        });
      } else if(res['status'] && res['result'].length == 0 ){
        this.onBack();
      }
    }, err => {
      this.spinner.hide();
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }


  getTaxSlab(data){
    this.arService.getTaxSlabByStation(data).subscribe(async res => {
      if (res['status']) {
       // console.log(res['status']);
       // console.log(res['result'][0].TAX_SLAB);
        this.taxSlab = res['result'][0].TAX_SLAB;
      } else {
       // console.log(res['message']);
      }
    }, err => {
     
      console.log(err);
    })
  }
  

  getSelectedCustomer(id) {
    for (let gg of this.arUnaasingedCustomers) {
      if (gg.CUSTOMER_ID == id) {
     
      this.selectedCustomerObject = gg;
      if(this.selectedCustomerObject.TRANSACTION_TYPE == 'Credit Card'){
        this.arUnTransactionForm.get('transactionType').setValue(this.selectedCustomerObject.TRANSACTION_TYPE);
        this.tTypeset = true;

      }else if(this.selectedCustomerObject == 'Cheque'){
        this.arUnTransactionForm.get('transactionType').setValue(this.selectedCustomerObject.TRANSACTION_TYPE);
        this.tTypeset = true;

      }else{
        this.arUnTransactionForm.get('transactionType').setValue(this.selectedCustomerObject.TRANSACTION_TYPE);
        this.tTypeset = false;
      }

      }
    }

   // console.log(this.arUnTransactionForm.value);
   // console.log(this.selectedCustomerObject)
  }


  getSelectedAgency(selectedAgency) {
   // console.log("Selected----",selectedAgency);
    this.arUnTransactionForm.patchValue({
      customerName: null
   });

    if (selectedAgency != "None") {
      let data = {
        station: this.station,
        agencyId : selectedAgency,
        agency : false
     }
      this.arService.getCustomersByStation(data).subscribe(res => {
        this.spinner.hide();
       // if (res['status'] && res['result'].length > 0) {
          this.arUnaasingedCustomers = res['result'];
       // }
      });
    }else {
      let data = {
        station: this.station,
        agency : false,
        agencyId : null
     }
      this.arService.getCustomersByStation(data).subscribe(res => {
        this.spinner.hide();
       if (res['status'] && res['result'].length > 0) {
          this.arUnaasingedCustomers = res['result'];
       }
      });
    }
  }

  submitCCType = false;

  submitTransation(data) {
   // console.log(data);
    this.validateTransaction()   
    this.submitted = true;
    this.arUnTransactionForm.markAllAsTouched();
    if (this.arUnTransactionForm.invalid) {
      return;
    }
    if ( (!this.arUnTransactionForm.controls.customerName.value) ||  (this.arUnTransactionForm.controls.customerName.value == 0 )) {
    this.notifier.notify('warning', 'Please Select Company Name');
    return;
    }

  
    let dDate;
    if(data.dueDate){
      dDate  = data.dueDate
    }
    const persistenceData = {
      RESID: this.reservationID,
      TRANSACTION_ID: this.arUnaasingedTransaction[0].TRANSACTION_ID,
      PAYMENT_STATUS: 'U',
      TAX_CALCULATED: data.taxes,
      TRANSACTION_AMOUNT: data.subTotal,
      TRANSACTION_TOTAL_AMOUNT: data.totalAmount,
      INVOICE_RECEIPT_ID: this.invoiceReceiptId,
      CUSTOMER_ID: data.customerName,
      CURRENCY_FLAG: this.arUnaasingedTransaction[0].CURRENCY_FLAG,
      DUE_DATE: dDate,
      LCB_ID: this.authService.getCurrentUserId(),
      TRANSACTION_TYPE : data.transactionType,
      AmountChangesStatus:this.amountChangeStatus,
      ACTIVE: 1,
      PURCHASE_ORDER : data.purchase_order,
      STATION : this.arUnaasingedTransaction[0].STATION
    }
    this.spinner.show();
    this.arService.savePaymentsOfTransaction(persistenceData).subscribe(async res => {
      this.spinner.hide();
      if (res['status']) {
        this.notifier.notify('success', 'Payment method successfully submitted.');
        this.submitCCType = true;
      await this.getAllInvoiceData();
      } else {
        this.notifier.notify('danger', 'Payment method Failed');
      }
    }, err => {
      this.spinner.hide();
      this.notifier.notify('danger', err.message)
      console.log(err);
    })

  }

  onBack() {
    this.router.navigateByUrl("home/ar-dashboard");
  }

  subTotal = 0;
  async getAllInvoiceData(){
    this.spinner.show();
    this.subTotal = 0;
   await this.arService.getInvoicePassengersDataByResId(this.reservationID).subscribe(async res => {
    this.spinner.hide();
      if (res['status']) {
       // this.notifier.notify('success', 'Payment method successfully submitted.');
      //  this.submitCCType = true;
      this.invoiceData = res['result'].invoice;
      this.miscServices = res['result'].miscService;
      this.flightInfo = res['result'].flight;
      this.passengers = res['result'].passenger;
       // console.log(res);
        // setTimeout(r => {
        //   this.router.navigateByUrl("home/ar-dashboard");
        // },3000)

        for(let j of res['result'].miscService){
          this.subTotal += (j.AMOUNT * j.QUANTITY);
        }
    
      } else {
       // this.notifier.notify('danger', 'Payment method Failed');
      }
    }, err => {
      this.spinner.hide();
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }


  saveInvoicePrint(){
    console.log('Calling....');
    const invoiceObj = {
      RESID: this.reservationID,
      PRINTED: 1,
      PRINTED_BY: this.authService.getCurrentUserId()
    }
    this.arService.updatePrintOfInvoice(invoiceObj).subscribe(async res => {
      if (res['status']) {
      //  console.log(res['status']);
      } else {
       // console.log(res['message']);
      }
    }, err => {
     
      console.log(err);
    })
  }
  invoiceForm: FormGroup;

  initAddInvoiceForm() {

    this.invoiceForm = new FormGroup({
      subTotal: new FormControl('', Validators.compose([Validators.required]))
    });
  }

  get f(): any {
    return this.arUnTransactionForm.controls;
  }

  amountChangeStatus = false;
  amountChangeCheckingFn(value){

   // console.log("TaxSlab : ",  this.taxSlab);

    const aa =parseFloat(this.arUnaasingedTransaction[0].TRANSACTION_SUBTOTAL);
    let formSubtotal = parseFloat(value);
   // console.log(event.value)
   if (aa && formSubtotal !== aa) {
    this.amountChangeStatus = true;
       // changed amount.

       let taxCal = formSubtotal * (this.taxSlab/100);

       let totalAmount = formSubtotal + taxCal ;


       this.arUnTransactionForm.controls['taxes'].setValue(taxCal);
       this.arUnTransactionForm.controls['totalAmount'].setValue(totalAmount);

    //   console.log('Changed:',aa  + " to "  +  formSubtotal + " ---> Tax: " + taxCal + " Toatal Amount : " + totalAmount);

   } else {
        //not changed...
      //  console.log('Not Changed:',aa , formSubtotal);
        this.amountChangeStatus = false;

        let taxCal = formSubtotal * (this.taxSlab/100);

        let totalAmount = formSubtotal + taxCal ;
 
 
        this.arUnTransactionForm.controls['taxes'].setValue(taxCal);
        this.arUnTransactionForm.controls['totalAmount'].setValue(totalAmount);
   }
  }

  getTime(date) {
    if(date == null){
      return '';
    }
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }

  getDate(date) {
    return moment.utc(date).format('MMM DD, YYYY')
  }
}
